import React from 'react';

import {
  LiveProvider,
  LiveEditor,
  LiveError,
  LivePreview
} from 'react-live';

export default ({ code, scope }) =>
  <div className="mb-4">
    <LiveProvider code={code} scope={scope} mountStylesheet={false}>
      <div className="mb-2">
        <LivePreview />
      </div>
      <LiveEditor />
      <LiveError />
    </LiveProvider>
  </div>
